import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-700', border: 'border-primary-200/60' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-700', border: 'border-accent-200/60' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', border: 'border-secondary-200/60' },
};

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            探索健康知识
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            从基础生理知识到日常护理技巧，我们为你提供全面、科学的私密健康指导
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group ${colors.bg} ${colors.border} border rounded-xl p-6 transition-all duration-300 hover:scale-[1.02] cursor-pointer`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${colors.bg} mb-4`}>
                  <i className={`${cat.icon} text-2xl ${colors.text}`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm text-primary-600 font-medium">
                  <span>查看全部</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}